import React from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { textMedium } from '../../../styles/texts';

const CommonButton = ({ onClick, text, textColor, ...rest }) => {
  return (
    <StyledButton
      {...rest}
      onClick={onClick}
      variant="contained"
      $textColor={textColor}
      sx={textColor ? { color: textColor, '& span': { color: textColor } } : undefined}
    >
      {text}
    </StyledButton>
  );
};


const StyledButton = styled(Button)`
  ${textMedium};  
  border-radius: 8px;
  text-transform: capitalize;
  padding: 10px 18px;
  min-width: 176px;
  font-size: 15px;
  color: ${({ theme, $textColor }) => $textColor ?? theme.color.background.secondary};
  ${({ $textColor }) => $textColor && `
    color: ${$textColor} !important;
    &, & span, & .MuiButton-startIcon, & .MuiButton-endIcon {
      color: ${$textColor} !important;
    }
  `}
`;

export default CommonButton;
